import { inMemoryKVStore } from '../../../infra/persistence';
export var shouldPathnameBeBlocked = function (pathname) {
    var allowedPathnames = [
        { path: /^\/settings\/payment-card$/ },
        { path: /^\/brand\/settings\/payment-card$/ },
        { path: /^\/barber\/settings\/payment-card$/ },
    ];
    return !allowedPathnames.some(function (_a) {
        var path = _a.path;
        return path.test(pathname);
    });
};
var DISMISSED_KEY = 'subscription-message-dismissed';
var DISMISSED_BY_ADMIN_KEY = 'subscription-message-dismissed-by-admin';
export var markAsDismissed = function () {
    // when the page is refreshing, the message should be displayed again. that's why we use inMemoryKVStore
    inMemoryKVStore.setItem(DISMISSED_KEY, 'true');
};
export var markAsDismissedByAdmin = function () {
    // when the page is refreshing, the message should be displayed again. that's why we use inMemoryKVStore
    inMemoryKVStore.setItem(DISMISSED_BY_ADMIN_KEY, 'true');
};
export var cleanUpDismissals = function () {
    inMemoryKVStore.removeItem(DISMISSED_BY_ADMIN_KEY);
    inMemoryKVStore.removeItem(DISMISSED_KEY);
};
export var shouldShowMessage = function (subscription) {
    if (!subscription || !subscription.showMessage) {
        return false;
    }
    var wasPreviouslyDismissedByAdmin = inMemoryKVStore.getItem(DISMISSED_BY_ADMIN_KEY) === 'true';
    if (wasPreviouslyDismissedByAdmin) {
        return false;
    }
    // blocking messages must appear no matter what
    if (subscription.blockAccess) {
        return true;
    }
    var wasPreviouslyDismissed = inMemoryKVStore.getItem(DISMISSED_KEY) === 'true';
    return !wasPreviouslyDismissed;
};
